import Chart from 'chart.js';
import 'chartjs-plugin-labels';
const childrens = window.childrens;
export default {
  init() {
    let fSizePie = 24;
    let paddingPie = 50;
    let paddingCountyPie = 0;
    let fSizeBar;

    if ($(window).width() < 991) {
      fSizePie = 14;
      paddingPie = 40;
      paddingCountyPie = 30;
    }

    if ($(window).width() < 400) {
      fSizePie = 12;
      paddingPie = 25;
      paddingCountyPie = 10;
    }

    if ($(window).width() > 991) {
      fSizeBar = 20;
    } else if ($(window).width() > 650) {
      fSizeBar = 12;
    }
    else {
      fSizeBar = 8;
    }
    Chart.defaults.global.tooltips = 'false';
// Gender ===========================================================
    let gender = document.getElementById('gender');
    let genderData = {
      labels: JSON.parse(childrens.gender_label),
      datasets: [{
        data: JSON.parse(childrens.gender_value),
        backgroundColor: JSON.parse(childrens.gender_backgroud_color),
        borderColor: JSON.parse(childrens.gender_backgroud_color),
      }],
    };
    let genderOption = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        'display': false,
      },
      pieceLabel: {
        render: 'value',
      },
      plugins: {
        labels: {
          render: 'label',
          fontSize: fSizePie,
          fontColor: JSON.parse(childrens.gender_text_color),
          textMargin: 10,
          position: 'outside',
          // fontFamily: 'tahoma',
          // fontStyle: 'bold',
        },
      },
      layout: {
        padding: {
          top: paddingPie,
          bottom: paddingPie,
          right: paddingPie,
          left: paddingPie,
        },
      },
    };
    new Chart(gender, {
      type: 'pie',
      data: genderData,
      options: genderOption,
    });

// Age-child ===========================================================
    let ageChild = document.getElementById('age-child');
    let ageChildData = {
      labels: JSON.parse(childrens.age_label),
      datasets: [{
        data: JSON.parse(childrens.age_value),
        backgroundColor: JSON.parse(childrens.age_backgroud_color),
        borderColor: JSON.parse(childrens.age_backgroud_color),
      }],
    };
    let ageChildOption = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        'display': false,
      },
      pieceLabel: {
        render: 'value', //show values
      },
      plugins: {
        labels: {
          render: 'label',
          fontSize: fSizePie,
          fontColor: JSON.parse(childrens.age_backgroud_color),
          textMargin: 15,
          position: 'outside',
          // fontFamily: 'tahoma',
          // fontStyle: 'bold',
        },
      },
      layout: {
        padding: {
          top: 30,
          bottom: 30,
          right: 30,
          left: 30,
        },
      },
    };
    new Chart(ageChild, {
      type: 'pie',
      data: ageChildData,
      options: ageChildOption,
    });

// County ===========================================================
    let county = document.getElementById('county');
    let countyData = {
      labels: JSON.parse(childrens.county_label),
      datasets: [{
        data: JSON.parse(childrens.county_value),
        backgroundColor: JSON.parse(childrens.county_backgroud_color),
        borderColor: JSON.parse(childrens.county_backgroud_color),
      }],
    };
    let countyOption = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        'display': false,
      },
      pieceLabel: {
        render: 'value',
      },
      plugins: {
        labels: {
          render: 'label',
          fontSize: fSizePie,
          fontColor: JSON.parse(childrens.county_backgroud_color),
          textMargin: 15,
          position: 'outside',
        },
      },
      layout: {
        padding: {
          top: paddingCountyPie,
          bottom: paddingCountyPie,
          right: paddingCountyPie,
          left: paddingCountyPie,
        },
      },
    };
    new Chart(county, {
      type: 'pie',
      data: countyData,
      options: countyOption,
    });

//Race of Child ===========================================================
    let childCanvas = document.getElementById('race-child');
    let childLineLength;
    if ($(window).width() > 991) {
      childLineLength = 70;
    } else if ($(window).width() > 575) {
      childLineLength = 50;
    } else {
      childLineLength = 20;
    }
    let childData = {
      labels: JSON.parse(childrens.race_title),
      datasets: [{
        data: JSON.parse(childrens.race_value),
        backgroundColor: '#3059aa',
        borderColor: '#3059aa',
      }],
    };
    let childOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        'display': false,
      },
      tooltips: {
        'enabled': false,
      },

      scales: {
        yAxes: [{
          display: false,
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
        }],
        xAxes: [{
          gridLines: {
            display: false,
          },
          barThickness: childLineLength,
          ticks: {
            fontSize: fSizeBar,
            padding: 20,
            fontColor: '#1d1d1d',
            // fontFamily: 'arial',
            // fontStyle: 'bold',
          },
        }],
      },
      plugins: {
        labels: {
          render: 'value',
          fontSize: fSizeBar,
          fontColor: '#1d1d1d',
          // fontFamily: 'arial',
          // fontStyle: 'bold',
          textMargin: 15,
        },
      },
      layout: {
        padding: {
          top: 62,
          bottom: 10,
        },
      },
    };
    new Chart(childCanvas, {
      type: 'bar',
      data: childData,
      options: childOptions,
    });

//Forensic Interviews ===========================================================
    let forensicCanvas = document.getElementById('forensic-interviews');
    let forensicLineLength;
    if ($(window).width() > 991) {
      forensicLineLength = 12;
    } else if ($(window).width() > 575) {
      forensicLineLength = 8;
    } else {
      forensicLineLength = 4;
    }
    let forensicData = {
      labels: JSON.parse(childrens.forensic_title),
      datasets: [{
        data: JSON.parse(childrens.forensic_value),
        backgroundColor: '#3059aa',
        borderColor: '#3059aa',
      }],
    };
    let forensicOptions = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        fontSize: 50,
      },
      legend: {
        'display': false,
      },
      tooltips: {
        'enabled': false,
      },
      scales: {
        yAxes: [{
          display: false,
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
        }],
        xAxes: [{
          gridLines: {
            display: false,
          },
          barThickness: forensicLineLength,
          ticks: {
            beginAtZero: true,
            autoSkip: false,
            maxRotation: 90,
            minRotation: 90,
            padding: 10,
            fontColor: '#1d1d1d',
            // fontFamily: 'arial',
            // fontStyle: 'bold',
            fontSize: fSizeBar,
          },
        }],
      },
      plugins: {
        labels: {
          render: 'value',
          fontSize: fSizeBar,
          fontColor: '#1d1d1d',
          // fontFamily: 'arial',
          // fontStyle: 'bold',
          textMargin: 10,
        },
      },
      layout: {
        padding: {
          top: 62,
          bottom: 20,
          right: 10,
          left: 10,
        },
      },
    };
    new Chart(forensicCanvas, {
      type: 'bar',
      data: forensicData,
      options: forensicOptions,
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateForensicInterviewing.js